/* eslint-disable */
export default {
  to: 'A:',
  enterNameOrPhoneNumber: 'Ingresar número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
